import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IMachine } from './machines'
import { machines } from './machines-sidecar'
import { machinesAnims } from './machinesAnims-sidecar'
import { oxygenModel } from '../models/oxygenModel-sidecar'

function ensure(obj: IMachine) {
  machines.ensureType(obj, 'o2gen-em')
}

const emergencyRate = 0.25
const oxygenSetPoint = 70
export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate
  obj.emergencySupply = 100
}

export function isRunning(obj: IMachine) {
  ensure(obj)
  return obj.emergencySupply > 0
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  let ds = common.getUpdateDeltaScaled()
  let ctx = scene.getContext()

  if (isRunning(obj)) {
    machinesAnims.playAnim(obj, machinesAnims.all.o2Go)
    machinesAnims.updateAnim(obj)

    let ot = oxygenModel.getTile(ctx.model, obj.i, obj.j)
    if (ot) {
      if (ot.o2 < oxygenSetPoint) {
        obj.emergencySupply -= emergencyRate * ds
      }
    }
  } else {
    spriteMap.setFrame(obj.image, obj.data.frames[0])
  }
}
